export default __webpack_public_path__ + "static/media/usdc.35406db8.svg";